import { z } from "zod";
import sceneObjectDataSchema from "./sceneObjectDataSchema";
import { vector3dSchema, quaternionSchema } from "../../primitivesSchema";

const textAnnotationDataSchema = sceneObjectDataSchema.extend({
    position: vector3dSchema,
    offset: vector3dSchema,
    text: z.string(),
    fontSize: z.number(),
    textNormal: vector3dSchema,
    textUp: vector3dSchema
  });

export default textAnnotationDataSchema;